import { render, staticRenderFns } from "./ReceiveMessageSetting.vue?vue&type=template&id=7e4e6ec1&scoped=true&lang=pug"
import script from "./ReceiveMessageSetting.vue?vue&type=script&lang=ts"
export * from "./ReceiveMessageSetting.vue?vue&type=script&lang=ts"
import style0 from "./ReceiveMessageSetting.vue?vue&type=style&index=0&id=7e4e6ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e6ec1",
  null
  
)

export default component.exports